module.exports = __webpack_public_path__ + "img/light_in_button.af5257e9.png";